import React from 'react';
import { Field, useFormikContext } from 'formik';
import dayjs from 'dayjs';

import { FormErrorUI, FormLabelUI, DatePickerUI, InputUI } from '../Interface';

const ExchangeRateSettingFields = ({ viewField }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="col-span-4 md:col-span-1">
        <Field
          type="number"
          name="numberOfDaysExchangeRate"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Az árfolybetöltés napjainak száma" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.numberOfDaysExchangeRate} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.numberOfDaysExchangeRate && values.numberOfDaysExchangeRate !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="lastExchangeRateLoaded"
          component={DatePickerUI}
          fullWidth
          label={<FormLabelUI text="Utolsó betöltött árfolyam" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.lastExchangeRateLoaded} />}
          onChange={(date) => {
            setFieldValue('lastExchangeRateLoaded', date).then(() => {
              validateField('lastExchangeRateLoaded');
            });
          }}
          value={values.lastExchangeRateLoaded ? dayjs.utc(values.lastExchangeRateLoaded) : null}
          disabled={true}
          InputLabelProps={{ shrink: values.lastExchangeRateLoaded !== '' }}
        />
      </div>
    </div>
  );
};

export default ExchangeRateSettingFields;
